// extracted by css-extract-rspack-plugin
export default {"envelope":"aXfctikKNRg0zdzx","codeMirror":"klWfp9VpBA07qcUV"};